import { ModifiedMapFilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";
import { isDefined } from "@mapmycustomers/shared/util/assert";

import standardHasIncompleteValue from "@app/component/filtering/utils/hasIncompleteValue";

import { FILTER_ENTITY_TYPES } from "./consts";

// same as standardHasIncompleteValue, but for maps
const hasIncompleteValue = (filters: ModifiedMapFilterModel): boolean =>
  FILTER_ENTITY_TYPES.some(
    (entityType) =>
      isDefined(filters[entityType]) && standardHasIncompleteValue(filters[entityType]!)
  );

export default hasIncompleteValue;
